import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Notifications } from '../models/notifications.interface';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  constructor(private readonly http: HttpClient) { }

  getNotifications(versionToken: string | null): Observable<Notifications.GetNotificationsResponse> {
    if (versionToken) {
      return this.http.get<Notifications.GetNotificationsResponse>(`/v1/notifications?versionToken=${encodeURIComponent(versionToken)}`);
    }
    return this.http.get<Notifications.GetNotificationsResponse>(`/v1/notifications`);
  }

  markNotificationsAsRead(notificationIds: number[]) {
    return this.http.post<any>('/v1/notifications/mark-read', notificationIds);
  }

  archiveNotifications(notificationIds: number[]) {
    return this.http.post<any>('/v1/notifications/archive', notificationIds);
  }
}
